/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

export const previousState = "previousStateMaintain";

export const homeState = "homeStateMaintain";

export const SaleCardView = "salecarditems";

export const viewMore = "viewMoreMaintain";

export const estateSaleCategory = "estateSaleCategoryMaintain";

export const biddingAndWatching = "BiddingAndWatching";

export const advanceSearchMain = "advanceSearchMainMaintain";

export const advanceSearchSub = "advanceSearchSubMaintain";

export const estateList = "estateSaleList";

export const watching = "watchingMaintain";

export const wonNotWon = "wonNotWonMaintain";

export const won = "wonMaintain";

export const notWon = "notWonMaintain";

export const locationList = "locationListMaintain";

export const favoriteLocationList = "favoriteLocationListMaintain";


/**
 * 
 * @param {string} name 
 * 
 * @param {object} data 
 */
export const convertToMaintainData = (name, data) => {
    window.sessionStorage.setItem(name, JSON.stringify(data));
}

/**
 * 
 * @param {string} name 
 * 
 * @returns {object} null or object 
 * 
 */
export const getMaintainData = (name) => {
    try {
        const previousValue = window.sessionStorage.getItem(name);
        const result = previousValue ? JSON.parse(previousValue) : null;
        window.sessionStorage.removeItem(name);
        return result;
    } catch (e) {
        return null;
    }
}

/**
 * To enable previous state maintain
 */
export const enablePreviousState = () => {
    try {
        convertToMaintainData(previousState, { apply: true });
    } catch (e) {
        console.error(e);
    }
}

/** 
 * To disable previous state
*/
export const disablePreviousState = () => {
    try {
        convertToMaintainData(previousState, { apply: false });
    } catch (e) {
        console.error(e);
    }
}

/**
 * 
 * @param {string[]} name keyname
 */
export const removeStateMaintainValue = (name) => {
    return new Promise((resolve, reject) => {
        try {
            name.forEach(key => {
                window.sessionStorage.removeItem(key);
            });
            resolve(true);
        } catch (error) {
            reject("")
        }
    });
}